import React from "react";
// import React, { useContext, useState } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { Link } from 'react-router-dom';
import {
  // Card,
  // Modal,
  Nav,
  // OverlayTrigger,
  // Tooltip,
  // Dropdown,
  // Form,
  Button
} from "react-bootstrap";
// import Login from 'components/authentication/simple/Login';
// import Registration from "components/authentication/simple/Registration";
// import AppContext from 'context/Context';
// import { useTranslation } from 'react-i18next';

const LandingRightSideNavItem = () => {
  // const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  // const {
  //   config: { isDark, isRTL },
  //   setConfig
  // } = useContext(AppContext);

  // const { i18n } = useTranslation();

  // function changeLanguage(e) {
  //   i18n.changeLanguage(e.target.value);
  // }

  // const {t} = useTranslation();

  return (
    <Nav navbar className="ms-auto align-items-left">
      {/* <Nav.Item as={'li'}>
        <Nav.Link
          className="pe-2 theme-switch-toggle"
          onClick={() => setConfig('isDark', !isDark)}
        >
          <OverlayTrigger
            key="left"
            placement={isRTL ? 'bottom' : 'left'}
            overlay={
              <Tooltip id="ThemeColor" className="d-none d-lg-block">
                {isDark ? 'Switch to light theme' : 'Switch to dark theme'}
              </Tooltip>
            }
          >
            <span>
              <div className="theme-switch-toggle-label">
                <FontAwesomeIcon
                  icon={isDark ? 'sun' : 'moon'}
                  className="me-2 text-white"
                />
              </div>
              <p className="d-lg-none mb-0">
                {isDark ? 'Switch to light theme ' : 'Switch to dark theme'}
              </p>
            </span>
          </OverlayTrigger>
        </Nav.Link>
      </Nav.Item> */}

      {/* <Dropdown>
        <Dropdown.Toggle as={Link} to="#!" className="nav-link fw-semi-bold text-white">
          {t('topbar.login')}
        </Dropdown.Toggle>
        <Dropdown.Menu className="dropdown-menu-end dropdown-menu-card mt-0 dropdown-caret dropdown-caret-bg">
          <Card className="navbar-card-login shadow-none">
            <Card.Body className="fs--1 fw-normal p-4">
              <Login />
            </Card.Body>
          </Card>
        </Dropdown.Menu>
      </Dropdown> */}

      {/* <Nav.Item>
        <Modal
          show={showRegistrationModal}
          centered
          onHide={() => setShowRegistrationModal(false)}
        >
          <Modal.Body className="p-0">
            <Card>
              <Card.Body className="fs--1 fw-normal p-4">
                <Registration />
              </Card.Body>
            </Card>
          </Modal.Body>
        </Modal>
      </Nav.Item> */}

      <Nav.Item>
        <a  href="/contact-us" className="nav_items">
          <Button variant="primary" size="sm" className="py-2 fw-bold">
            Contact Us
          </Button>
        </a>
        {/* <Nav.Link href="contact-us" className="nav_items">
        <Button variant="primary" size="sm">Contact Us</Button>
      </Nav.Link> */}
      </Nav.Item>
      {/* <Nav.Item>
      <Nav.Link href="#link">
            <Form.Select size="sm" id='customLang' onChange={changeLanguage}>
                <option value={'en'} >English</option>
                <option value={'fr'}>French</option>
            </Form.Select>
        </Nav.Link>
      </Nav.Item> */}
    </Nav>
  );
};

export default LandingRightSideNavItem;
